import { Box } from '@chakra-ui/react';
import type { FC } from 'react';

import type { ContainerProps } from './types';

const Container: FC<ContainerProps> = ({ children, ...props }) => {
  return (
    <Box {...props} mx="24px">
      {children}
    </Box>
  );
};

export default Container;
